export const environment = {
  toolsAI: 'http://localhost:8000',
  BASE_URL_APP: 'http://localhost:8000',
  OLLAMA_API_URL: 'http://localhost:3232',

  OLLAMA_API_KEY: 'llm_ollama',

  OLLAMA_MODEL_EXTRACT: 'llama3.2:3b-instruct-fp16',



  LM_STUDIO_API_URL: 'http://192.168.2.82:45388/v1/',
  LM_STUDIO_API_KEY: 'lm_studio',

  LM_STUDIO_MODEL_EXTRACT: 'llama3.2-3b-instruct',
  LM_STUDIO_MODEL_INTENT: 'llama3.2-3b-instruct',
//Integrados para test caso de uso real
  TOGETHER_API_URL: 'https://api.together.xyz/v1/',

  TOGETHER_MODEL_EXTRACT: 'meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8',
  TOGETHER_MODEL_INTENT: 'openai/gpt-oss-20b',
  TOGETHER_MODEL_EMBEDDING_DEDICATED: 'togethercomputer/m2-bert-80M-32k-retrieval',
  TOGETHER_MODEL_EMBEDDING: 'Alibaba-NLP/gte-modernbert-base',

  _TOGETHER_MODEL_INTENT: 'meta-llama/Llama-3.2-3B-Instruct-Turbo',
  TOGETHER_MODEL_RASONING: 'openai/gpt-oss-120b',
  TOGETHER_MODEL_RASONING_FREE: 'ServiceNow-AI/Apriel-1.5-15b-Thinker',
  TOGETHER_MODEL_RASONING_DEEP: 'Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8',
  TOGETHER_MODEL_RASONING_DEEP_two: 'deepseek-ai/DeepSeek-V3.1',
  DEPRECTAED_TOGETHER_MODEL_RASONING_DEEP: 'deepseek-ai/DeepSeek-V3',
  TOGETHER_MODEL_PHOTO_GENERATOR: 'black-forest-labs/FLUX.1-schnell-Free',
  TOGETHER_MODEL_ALTERNATIVE: 'meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8',
  _TOGETHER_MODEL_ALTERNATIVE: 'meta-llama/Llama-Vision-Free',

  API_MAX_RETRIES: 5,
  API_TIMEOUT: 25000,

  ASSEMBLYAI_API_URL: 'https://www.assemblyai.com/',


  //-+--+--+-+--++-++-+-+--+-++-+--+--+-+-

  googleTtsApiKey: 'AIzaSyAbGot2XSpZdGXp0VpaGdDRR6Lg8bPIJso',
  SEARCH_GOOGLE_API_KEY: "AIzaSyBZBkIf1uvR898myg0HfNgiopAGnDqPExU",
  SEARCH_GOOGLE_CSE_ID : "b164ca1871dfb4652",
  ASSEMBLYAI_API_KEY_: '9e9352d5bc714f3ebc7973bf9d2eff93',
  ASSEMBLYAI_API_KEY: '44db8b7c2f58496ba2baa305dcbbedea',
  TOGETHER_API_KEY_TEST_: 'tgp_v1_a6zSf5pN21WjsSFDVFFJTfgNQzCmPw0BkJtS0ss5dYo',
  TOGETHER_API_KEY: 'tgp_v1_UNXX3n4l61VIWC5mKoNomrUwegHHPlfUcI0kqcEqjmg',
  TOGETHER_API_KEY_0: 'tgp_v1_k5UVREUE7REQRV9XJyrIq6OrLO8MBFkXGvY4echgyPk',
  TOGETHER_API_KEY_1: 'tgp_v1_n3pdED2GEehJO_wriadmDhKCWpRCupNRKsZJm72-b-o',
  TOGETHER_API_KEY_2: 'tgp_v1_ADrAeMzm3fwFW_U7ome2G1AbF9BA127wefvBTm-7Mbg',
  TOGETHER_API_KEY_TEST: 'tgp_v1_c-tPZ70BKaSGBK2g2_W-oVsBNOK13xYMyPjS9tVIhm4',
  TOGETHER_API_KEY_3: 'tgp_v1_blmf4rFqyp6wfkQ66KLaddsKi_rLeGE0uPQ9GnSfKhI',
  TOGETHER_API_KEY_4: 'tgp_v1_btprMIGh64u2iuRjP04u9Y-16VTEX8IpR9dcKWYPm8Y',
  TOGETHER_API_KEY_5: 'tgp_v1_gU1LUQckM9-w_fhnRvNMIfmmN8vbZD8zhohbYL2GfaY',
  TOGETHER_API_KEY_6: 'tgp_v1_ugcYkaRO7qG1jn_CoW2FVIHA1GChYV0ZwklUXooSlos',
  TOGETHER_API_KEY_7: 'tgp_v1_ugcYkaRO7qG1jn_CoW2FVIHA1GChYV0ZwklUXooSlos',
  //_-+--+--+-+--++-++-+-+--+-++-+--+--+-+-_

  //NOTA: Para servicios de google cloud se debe usar el puerto(en local 4***8)

  gcp: {
    projectId: 'tools-ai-tecinco',
    apiKey: 'AIzaSyBmunmKygZ_xAlm9c0bu7I-qNhf5yIqrQE'
  },
  visualize_logs: true,
  console_logs: {
    info: true,
    warn: true,
    error: true,
    debug: true,

  }


};
